import { SIZE_MAP } from '@flex-design-system/stitches-react';

const PRESET_SIZE_LIST = Object.keys(SIZE_MAP);
function isPresetSize(size) {
  return PRESET_SIZE_LIST.some((s) => s === size);
}

export { isPresetSize };
//# sourceMappingURL=size.mjs.map
